module.exports = __webpack_public_path__ + "91b36360e649447568ebf3bbcd217aa4.png";